<ng-container *transloco="let t; prefix: 'experience'">
  <div [ngClass]="headerBG" class="experience-header">
    <header [ngClass]="{experience: !isBookingExperience}">
      @if (isBookingExperience) {
        <button
          type="button"
          data-cy="back-button"
          [attr.aria-label]="t('back')"
          title="{{ t('backButton') }}"
          (click)="back()"
          tabindex="0"
          class="back"
        >
          <i class="icon" [innerHTML]="backIcon"></i>
        </button>
      }
      @if ((titleVisible && isMobileResolution) || !isMobileResolution) {
        <div @fadeAnimation class="title-container">
          <h2 class="heading-s" data-cy="header-title"
            ><strong>{{ title }}</strong></h2
          >
          @if (date) {
            <h3 class="date day-date" data-cy="header-date"
              >{{ date | essDate: EssDateFormat.Long }}
              @if (time) {
                <span>⋅ {{ time }}</span>
              }
            </h3>
          }
        </div>
      }
      @if (isBookingExperience && !isSampleTrip) {
        <ess-open-confirmation [status]="status" [id]="id" [hash]="hash" data-cy="header-confirmation-button" />
      }
      <button
        [matMenuTriggerFor]="menu"
        [attr.aria-label]="t('usersMenu')"
        class="vertical-menu"
        data-cy="users-menu"
        mat-icon-button
        type="button"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button
          (click)="copyToClipboard()"
          [attr.aria-label]="t('copyToClipboard')"
          data-cy="menu-share-experience"
          mat-menu-item
          matTooltip="Copy URL to the clipboard"
          type="button"
        >
          <span>{{ t('shareThisExperience') }}</span>
        </button>
        @if (isBookingExperience) {
          @if (loggedIn$ | async) {
            <button mat-menu-item [attr.aria-label]="t('logout')" (click)="logOut()" type="button">
              <span>{{ t('logout') }}</span>
            </button>
          } @else {
            <button mat-menu-item [attr.aria-label]="t('login')" type="button" (click)="logIn()">
              <span>{{ t('login') }}</span>
            </button>
          }
        }
      </mat-menu>
    </header>
    <div class="scroller">
      <hr [style.width.%]="scrollRatio" data-cy="header-scroller" />
    </div>
    <div class="border"></div>
  </div>
</ng-container>
